import { CmsCarouselSlide } from "@/features/shop/cms/components/CmsCarouselSlide";
import type { CmsBlock } from "@/features/shop/cms/types/cms.types";
import type { CarouselSlide } from "@/features/shop/components/Carousel";
import type { AutoScrollCardItem } from "@/features/shop/types/autoScrollSlider.types";

/**
 * Identifiant stable d'un bloc pour les clés React. Un bloc créé dans un brouillon affiché en
 * aperçu n'a pas encore d'id : on retombe sur sa position dans la section.
 */
export const cmsBlockKey = (block: CmsBlock, index: number): string =>
  (block.id !== null && block.id !== undefined ? String(block.id) : `apercu-${block.position}-${index}`);

export const transformCmsBlocksToSlides = (blocks: CmsBlock[]): CarouselSlide[] => {
  const sortedBlocks = [...blocks].sort((a, b) => a.position - b.position);

  return sortedBlocks.map((block, index) => ({
    id: cmsBlockKey(block, index),
    content: <CmsCarouselSlide block={block} />,
  }));
};

export const transformCmsBlocksToCarouselSlides = (blocks: CmsBlock[]): CarouselSlide[] => {
  const sortedBlocks = [...blocks].sort((a, b) => a.position - b.position);

  return sortedBlocks.map((block, index) => ({
    id: cmsBlockKey(block, index),
    content: <CmsCarouselSlide block={block} />,
  }));
};

export const transformCmsBlocksToAutoScrollCards = (blocks: CmsBlock[]): AutoScrollCardItem[] => {
  const sortedBlocks = [...blocks].sort((a, b) => a.position - b.position);

  return sortedBlocks.map((block, index) => ({
    id: cmsBlockKey(block, index),
    title: block.title,
    subtitle: block.subtitle || undefined,
    backgroundColor: block.background_color,
    image: block.media_url || undefined,
    imageBackground: block.media_background_color || undefined,
    link: block.link_url,
  }));
};
